//@ts-nocheck

'use client'

import React, { useContext } from 'react'
import { ColorSchemeTypes } from '../../../types/ColorScheme'
import { CtaTypes } from '../../../types/Cta'
import { SectionThemeContext } from '../../../contexts/SectionTheme.context'
import FaqSimple from './variants/FaqSimple.component'
import FaqSpecified from './variants/FaqSpecified.component'
import * as S from './Faq.styles'
import { Container } from '../../atoms/GridSystem'

type FaqType = 'FaqSimple' | 'FaqSpecified'

interface FaqProps {
  sectionId?: string
  type: FaqType
  colorScheme?: ColorSchemeTypes
  title?: string
  cta?: CtaTypes
  faqs?: Array<{
    question: string
    answer: string
  }>
  groups?: Array<{
    title: string
    faqs: Array<{
      question: string 
      answer: string
    }>
  }>
}

const Faq: React.FC<FaqProps> = ({ sectionId, type, ...props }) => {
  const { selectedColorScheme } = useContext(SectionThemeContext)

  const dispatcher = {
    FaqSimple,
    FaqSpecified,
  }

  const Component = dispatcher[type]

  return Component ? (
    <Container>
      <S.Faq colorScheme={selectedColorScheme} as="section" id={sectionId}>
        <Component {...props} />
      </S.Faq>
    </Container>
  ) : null
}

export default Faq
